<div (click)="jumpToTime(note?.recordedTime)" class="truncate" style="word-break: break-all;" [title]="note?.description"><i *ngIf="note?.recordedTime != '-1'"
    class="icon-circleplay leftmultiicons"></i>
  <i *ngIf="note?.recordedTime == '-1'"
    class="icon-excercise leftmultiicons"></i>{{truncate?note?.truncatedText:note.description}}<button
    *ngIf="showToggle" (click)="truncate=!truncate;$event.stopImmediatePropagation();"> {{truncate?"Read more":"Show less"}}</button></div>
<div class="action-list">
  <span *ngIf="note?.recordedTime != '-1'" class="time">{{note?.recordedTime | formatSec}}</span>
  <div ngbDropdown class="dropdown dropdown-action">
    <button class="btn btn-link dropdown-toggle" ngbDropdownToggle type="button" id="dropdownBasic1">
      <i class="icon-more"></i>
    </button>
    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownBasic1">
      <button class="dropdown-item" (click)="onEdit()">Edit</button>
      <button class="dropdown-item" (click)="onRemove()">Delete</button>
    </div>
  </div>
</div>
